// Mirrors _features/subscriptions/state/slice.js's shape (selectedFilters +
// customColumns, REHYDRATE normalization) - does NOT carry forward the old
// plain `features/Invoice/invoiceApiSlice.js`'s `invoices`/`invoicePayment`/
// `summary` mirroring (dead-sync pattern already dropped for the other 3
// features migrated this session).
//
// Separate Redux key (`invoicesFeature`, plural) from the legacy `invoice`
// slice (singular) - that old slice stays registered for its own remaining
// consumers (Pay portal, SelfServeDetails), see docs/known-issues.md.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const invoicesFeatureSlice = createSlice({
  name: "invoicesFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.invoicesFeature) {
        const persistedData = action.payload.invoicesFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } =
  invoicesFeatureSlice.actions;

export default invoicesFeatureSlice.reducer;
